import React from 'react';
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, FormHelperText, Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export default function SwitchInput(props) {

  const { label, errors, helpText, switchColumnSize, ...switchProps } = props;

  const columnSize = switchColumnSize || 12;

  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl component="fieldset" error={!!errors}>
          <FormControlLabel
            control={
              <Switch {...switchProps} />
            }
            label={label}
          />
          <FormHelperText>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText}>
              <InfoIcon color="primary"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

SwitchInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  helpText: PropTypes.string,
  errors: PropTypes.object,
}
